import React from 'react';
import { View, NotFoundBoundary } from 'react-navi';

function RootApp() {
    return (
        <div className="App has-cpck">
            <main>
                <div className="is-misscircle cpck-window cpck-banner cpck-type-info cpck-theme-block cpck-bottom">
                    <span id="cupcakeconsent:desc" className="cpck-message"><strong className="has-text-weight-bold">大学・専門学生募集中！</strong><br />2010年度の初開催から続く歴史の中で、夢を抱く学生たちがこの舞台から羽ばたき、アナウンサーやタレント、アイドル、インフルエンサーとして活躍しています。</span>
                    <div className="cpck-compliance">
                        <a aria-label="dismiss cookie message"
                           href="https://liff.line.me/1653526546-OmK7dK4L/entry?utm_source=misscircle2023&utm_medium=operation"
                           className="cpck-btn cpck-dismiss"><span>💎</span>エントリー方法を確認する</a>
                    </div>
                </div>
                <NotFoundBoundary render={renderNotFound}>
                    <View />
                </NotFoundBoundary>
            </main>
        </div>
    );
}

// Note that create-react-navi-app will always show an error screen when this
// is called. This is because the underlying react-scripts package show
// the error screen when a NotFoundError is thrown, even though it's caught
// by <NotFoundBoundary>. To see the error rendered by this function,
// you'll just need to close the error overlay with the "x" at the top right.
function renderNotFound() {
    return (
        <div className="App-error">
            <h1>404 - Not Found</h1>
        </div>
    );
}

export default RootApp;